import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Comments",
  "use": "Comments-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Comments\"><g fill-rule=\"evenodd\"><path d=\"M2.25 15.908h19.49V3.402H2.25v12.506zM24 .667H0v17.977h3.541v4.69l7.307-4.69H24V.667z\" /><text font-family=\"GothamBold, Gotham Bold\" font-size=\"12\" font-weight=\"bold\" letter-spacing=\"-.8\"><tspan x=\"5.282\" y=\"13.5\">28</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol